import {firebase} from './firebase';

export const getAllCategories = () =>
  firebase.database().ref('stores_categories/').once("value");

export const getCategoriesByRestaurant = (idRestaurant) =>
  firebase.database().ref('stores_categories/'+idRestaurant).once("value");
  export const getFieldsByRestaurant = (idRestaurant) =>
  firebase.database().ref('stores_fields/'+idRestaurant).once("value");

export const getAllRestaurants = () =>
  firebase.database().ref('stores_profiles/').once("value");

export const getPublishedRestaurants = (callback) =>
  firebase.database().ref('stores_permissions/').orderByChild('publish').equalTo(true).on("value", (publishedRestaurants) => {
    callback(publishedRestaurants);
  });

export const getRestaurant = (idRestaurant) =>
    firebase.database().ref('stores_profiles/'+idRestaurant).once("value");

export const getAllPositions = () =>
  firebase.database().ref('stores_locations/').once("value");

export const checkSchedules = (idRestaurant, callback) =>
  firebase.database().ref('stores_schedules/'+idRestaurant).on("value", (schedules) => {
    callback(schedules);
  });

export const getFoodByRestaurant = (idRestaurant, callback) =>
  firebase.database().ref('products/'+idRestaurant).on("value", (food) => {
    callback(food);
  });

  export const checkAllowOrders = (idRestaurant, callback) =>
    firebase.database().ref('stores_permissions/'+idRestaurant).on("value", (restaurant) => {
      callback(restaurant);
    });


// WEBPACK FOOTER //
// ./src/restaurantDB.js